import { usePermission } from "@how/app-kit";
import { Anchor, Card, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router";

/**
 * The way into Settings → Sign-in addresses (ADR 0067 S1). Only someone the database lets manage them
 * (domains.manage_signin, the church's owners) sees it; the route checks again, and every change is checked in the
 * database.
 */
export function SignInAddressesCard() {
  const allowed = usePermission("domains.manage_signin");
  if (allowed.data !== true) return null;
  return (
    <Card>
      <Stack gap="xs">
        <Title order={2} size="h4">
          Sign-in addresses
        </Title>
        <Text size="sm" c="dimmed">
          Let staff and members sign in on your church's own domain, such as dash.yourchurch.org.
          HoW's addresses keep working.
        </Text>
        <Anchor component={Link} to="/settings/sign-in-addresses" size="sm" fw={600}>
          Manage sign-in addresses
        </Anchor>
      </Stack>
    </Card>
  );
}
